import PageHeader from "components/PageHeader";

const videos = [
  {
    title: "Life of Eagles",
    description: "Documentary about the majestic eagles and their habitat",
    duration: "15:30",
  },
  {
    title: "Tropical Parrots",
    description: "Colorful world of tropical parrots and their behaviors",
    duration: "22:45",
  },
  {
    title: "Migration Patterns",
    description: "Understanding bird migration across continents",
    duration: "18:20",
  },
];

const educationalFeatures = [
  {
    title: "Nature Documentaries",
    description:
      "Professional documentaries showcasing bird behavior and habitats.",
  },
  {
    title: "Educational Content",
    description: "Learning videos perfect for students and bird enthusiasts.",
  },
  {
    title: "Behind the Scenes",
    description: "Exclusive footage showing daily life at Mysher Aviary.",
  },
];

const Videos = () => {
  return (
    <div className="min-h-screen pt-0">
      <PageHeader
        title="Videos"
        subtitle="Watch our collection of bird documentaries and educational content"
      />

      <div className="bg-white py-20 max-[768px]:py-[60px]">
        <div className="container">
          <div className="grid grid-cols-2 items-start gap-16 max-[968px]:grid-cols-1 max-[968px]:gap-8">
            <div className="mb-12">
              <h2 className="mb-8 text-4xl font-bold text-primary-blue max-[768px]:text-3xl">
                Featured Videos
              </h2>
              <div className="mt-8 grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-8">
                {videos.map((video) => (
                  <div
                    key={video.title}
                    className="overflow-hidden rounded-xl bg-white shadow-[0_4px_15px_rgba(0,0,0,0.1)] transition-transform duration-300 hover:-translate-y-1.5"
                  >
                    <div className="relative flex h-[180px] items-center justify-center bg-gradient-to-br from-primary-blue to-secondary-blue text-5xl text-white before:text-4xl before:content-['▶']">
                      <span className="absolute bottom-2.5 right-2.5 rounded bg-black/70 px-2 py-1 text-xs text-white">
                        {video.duration}
                      </span>
                    </div>
                    <h3 className="px-6 pb-2 pt-4 font-semibold text-primary-blue">
                      {video.title}
                    </h3>
                    <p className="mb-4 px-6 text-[0.95rem] text-text-light">
                      {video.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-12">
              <h2 className="mb-8 text-4xl font-bold text-primary-blue max-[768px]:text-3xl">
                Educational Series
              </h2>
              <p className="mb-8 text-lg leading-[1.7] text-text-light">
                Explore our comprehensive video library featuring
                documentaries, educational content, and behind-the-scenes
                footage from Mysher Aviary.
              </p>

              <div className="mt-8">
                {educationalFeatures.map((feature, index) => (
                  <div
                    key={feature.title}
                    className={`mb-8 border-b border-[#e9ecef] pb-8 ${
                      index === educationalFeatures.length - 1
                        ? "mb-0 border-b-0"
                        : ""
                    }`}
                  >
                    <h3 className="mb-2 font-semibold text-primary-blue">
                      {feature.title}
                    </h3>
                    <p className="mb-0 text-text-light">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Videos;
